import React, { useContext, useEffect } from 'react';
import progressContext from '../../context/loading/progresscontext';
import footerMenuContext from '../../context/footermenu/footermenucontext';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

function TermsAndConditions() {
    const { setProgress } = useContext(progressContext);
    const { disclaimer } = useContext(footerMenuContext);

    useEffect(() => {
        if (setProgress) {
            setProgress(70);
            setTimeout(() => {
                setProgress(100);
            }, 100);
        }
    }, [setProgress]);

    return (
        <main>
            <Breadcrumb
                pageName="Terms and Conditions"
                bgImage="/img/uplaods/rad.jpg"
                path={[
                    { label: 'Home', href: '/' },
                    { label: 'Terms & Conditions' }
                ]}
            />
            <section className="band">
                <div className="wrap" style={{ maxWidth: '800px' }}>
                    <div className="terms-content" style={{ fontSize: '16px', lineHeight: '1.7', color: 'var(--muted)' }}>
                        {disclaimer && disclaimer.terms_n_conditions ? (
                            <div dangerouslySetInnerHTML={{ __html: disclaimer.terms_n_conditions }}></div>
                        ) : (
                            <div>
                                <p>Welcome to Lakshmi Maternity &amp; Surgical Centre. By accessing or using our website and services, you agree to comply with and be bound by the following terms and conditions of use.</p>
                                <p style={{ marginTop: '16px' }}>The information provided on this website is for general informational and educational purposes only and should not be substituted for professional medical advice, diagnosis, or treatment.</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
}

export default TermsAndConditions;